import {
    FETCH_INITIAL_NOTES_DATA_REQUEST,
      FETCH_INITIAL_NOTES_DATA_SUCCESS,
      FETCH_INITIAL_NOTES_DATA_FAILURE,
    } from "./FetchInitialNotesDataTypes";
    import api from "../../utils/Api";
    
    export const fetchInitialNotesDataRequest = () => {
      return {
        type: FETCH_INITIAL_NOTES_DATA_REQUEST,
      };
    };
    
    export const fetchInitialNotesDataSuccess = (initialNotesData) => {
      return {
        type: FETCH_INITIAL_NOTES_DATA_SUCCESS,
        payload: initialNotesData,
      };
    };
    
    export const fetchInitialNotesDataFailure = (error) => {
      return {
        type: FETCH_INITIAL_NOTES_DATA_FAILURE,
        payload: error,
      };
    };
    
    export const fetchInitialNotesDataListing = () => {
      
      const headers = {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      };
      let url = "dashboard/notes/initialData/fetch";
    
      
      return async (dispatch) => {
        dispatch(fetchInitialNotesDataRequest);
        try {
          const response = await api.get(url,
            {
              headers: headers,
            }
          );
          const initialNotesData = response.data.data;
         // console.log("initialNotesData", initialNotesData)
          dispatch(fetchInitialNotesDataSuccess(initialNotesData));
        } catch (error) {
          console.log("Redux error - ", error.response);
          const errorMsg = error.message;
          dispatch(fetchInitialNotesDataFailure(errorMsg));
        }
      };
    };
    